<template>
  <v-app>
    <v-container
      class="background"
      fluid
      :style="{backgroundImage: background}" style="overflow: auto;">
      <v-row
        v-if="twoFa"
        style="height: 100%"
        align="center"
        justify="center">
        <v-col
          cols="12" sm="8" md="6"
          lg="4" :style="qrStyle">
          <div v-if="qrCode" class="text-center">
            <v-row justify="center">
              <v-col
                cols="4" md="3" lg="4">
                <a
                  v-if="logoLink" :href="logoLink" target="_blank"
                  style="display: flex; justify-content: center;">
                  <v-img
                    alt="GDi Smart Portal"
                    contain
                    max-height="100px"
                    :src="logoSrc" />
                </a>
                <v-img
                  v-else
                  alt="GDi Smart Portal"
                  style="display: flex; justify-content: center;"
                  contain
                  max-height="100px"
                  :src="logoSrc" />
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-spacer />
              <v-card-title
                class="text-center app-name">
                {{
                  appName
                }}
              </v-card-title>
              <v-spacer />
            </v-row>
            {{ labels.qrCode }}
            <br>
            {{ labels.googleAuthenticator }}
            <br>
            <img class="pt-2 pb-2" width="200" :src="'data:image/png;base64,' + qrCode">
          </div>
          <div v-if="!qrCode" class="text-center">
            <v-row justify="center">
              <v-col
                cols="4" md="3" lg="4">
                <a
                  v-if="logoLink" :href="logoLink" target="_blank"
                  style="display: flex; justify-content: center;">
                  <v-img
                    alt="GDi Smart Portal"
                    contain
                    max-height="100px"
                    :src="logoSrc" />
                </a>
                <v-img
                  v-else
                  alt="GDi Smart Portal"
                  style="display: flex; justify-content: center;"
                  contain
                  max-height="100px"
                  :src="logoSrc" />
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-card-title
                class="pb-0 mb-0 px-4 px-sm-12 text-center app-name">
                {{
                  appName
                }}
              </v-card-title>
              <v-spacer />
            </v-row>
            <div class="pa-4">
              {{ labels.twoFaChallenge }}
            </div>
          </div>
          <div v-if="twoFaChallenge" class="text-center">
            <div :style="twoCodeTextStyle">
              <v-text-field
                v-model="twoFaCode"
                background-color="white"
                label="2fa code"
                color="black"
                outlined
                autofocus="true"
                @keydown.enter="login2fa" />
              <BasePrimaryBtn :loading="loggingIn" title="OK" @click="login2fa" />
            </div>
          </div>
        </v-col>
      </v-row>

      <v-row v-else style="height: 100%">
        <v-col v-if="isSmallScreen || isXSmallScreen" cols="4">
          <v-spacer />
        </v-col>
        <v-col
          cols="4" md="3" lg="4"
          class="pt-12 pl-md-16" />
        <v-col v-if="isSmallScreen || isXSmallScreen" cols="4">
          <v-spacer />
        </v-col>
        <v-col v-if="isSmallScreen" cols="2">
          <v-spacer />
        </v-col>
        <v-col
          cols="12" sm="8" md="6"
          lg="4" align-self="center" class="px-sm-0 px-8">
          <v-card id="login-card" class="elevation-5 mx-sm-8 py-sm-4 py-2">
            <v-row justify="center">
              <v-col
                cols="4" md="3" lg="4"
                class="pb-0 mb-0">
                <a
                  v-if="logoLink" :href="logoLink" target="_blank"
                  style="display: flex; justify-content: center;">
                  <v-img
                    alt="GDi Smart Portal"
                    contain
                    max-height="100px"
                    :src="logoSrc" />
                </a>
                <v-img
                  v-else
                  alt="GDi Smart Portal"
                  style="display: flex; justify-content: center;"
                  contain
                  max-height="100px"
                  :src="logoSrc" />
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-card-title
                class="pb-0 mb-0 px-4 px-sm-12 text-center app-name">
                {{
                  appName
                }}
              </v-card-title>
              <v-spacer />
            </v-row>
            <v-row>
              <v-spacer />
              <v-card-subtitle :class="['pt-2']" style="font-size: 18px">
                {{
                  labels.welcome
                }}
              </v-card-subtitle>
              <v-spacer />
            </v-row>
            <v-card-text v-if="smartPortal" class="py-0 py-sm-2 px-sm-8">
              <v-form>
                <BaseTextField
                  id="txt-username"
                  v-model="username"
                  :label="labels.username"
                  type="text"
                  :dense="isXSmallScreen"
                  class="py-4"
                  :disabled="disableCredentialInputFields"
                  @keydown.enter="login" />
                <BaseTextField
                  id="txt-password"
                  v-model="password"
                  :label="labels.password"
                  :dense="isXSmallScreen"
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPass ? 'text' : 'password'"
                  class="py-4"
                  :disabled="disableCredentialInputFields"
                  @keydown.enter="login"
                  @click:append="showPass = !showPass" />
              </v-form>
            </v-card-text>
            <v-card-actions class="py-0 px-sm-8">
              <v-container fluid class="pa-0">
                <v-row v-if="smartPortal" class="py-0">
                  <v-col cols="12" align-self="center" class="py-4">
                    <BasePrimaryBtn :title="labels.signin" @click="login" />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col
                    v-if="facebook" cols="colNumber" :align="isSmallScreen || isXSmallScreen ? 'center' : ''">
                    <v-btn
                      style="font-weight: 300"
                      :x-large="!isXSmallScreen"
                      width="100%" class="no-uppercase" outlined
                      :color="socialNetworkColor"
                      @click.prevent="loginWithFacebook">
                      <v-icon color="blue">
                        mdi-facebook
                      </v-icon>
                      <span
                        v-if="!isXSmallScreen"
                        class="pl-0 pr-2"
                        style="font-size: 17px; font-weight: 400">{{ labels.facebook }}</span>
                    </v-btn>
                  </v-col>
                  <v-col v-if="google" cols="colNumber" :align="isSmallScreen || isXSmallScreen ? 'center' : ''">
                    <v-btn
                      style="font-weight: 300"
                      :x-large="!isXSmallScreen"
                      width="100%" class="no-uppercase" outlined
                      :color="socialNetworkColor"
                      @click.prevent="loginWithGoogle">
                      <v-icon color="red">
                        mdi-google
                      </v-icon>
                      <span
                        v-if="!isXSmallScreen"
                        class="pl-0 pr-2"
                        style="font-size: 17px; font-weight: 400">{{ labels.google }}</span>
                    </v-btn>
                  </v-col>
                  <v-col v-if="arcGISPortal && isArcGISPortalUrlSupplied" cols="colNumber" :align="isSmallScreen || isXSmallScreen ? 'center' : ''">
                    <v-btn
                      style="font-weight: 300"
                      :x-large="!isXSmallScreen"
                      width="100%" class="no-uppercase" outlined
                      :color="socialNetworkColor"
                      @click.prevent="loginWithArcGISPortal">
                      <v-icon color="green">
                        mdi-earth
                      </v-icon>
                      <span
                        v-if="!isXSmallScreen"
                        class="pl-0 pr-2"
                        style="font-size: 17px; font-weight: 400">{{ labels.arcGISPortal }}</span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="!loginOnly && smartPortal" class="pt-2" justify="center">
                  <v-col class="pa-0" cols="auto">
                    <span
                      link :style="{cursor: 'pointer', fontSize: '16px'}" class="v-card__subtitle"
                      @click="dialog = true">
                      {{ labels.createAccount }}
                    </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-progress-linear
                    v-if="loggingIn"
                    color="primary"
                    indeterminate
                    class="mr-2" />
                </v-row>
                <v-row v-if="languages.length > 1" class="pl-4 pt-8">
                  <v-icon color="black">
                    mdi-web
                  </v-icon>
                  <div
                    v-for="(lang, i) in languages" :key="i"
                    class="pa-1 ma-0"
                    cols="3">
                    {{ i > 0 ? '|' : '' }}
                    <v-btn
                      :color="i === activeIndex ? 'black' : 'grey'"
                      :text-color="i === activeIndex ? 'black' : 'grey'"
                      small
                      text
                      @click="setLanguage(lang, i)">
                      {{ lang.title }}
                    </v-btn>
                  </div>
                </v-row>
              </v-container>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4" />
      </v-row>
      <v-snackbar v-model="error" color="error" multi-line>
        {{ labels[snackbarMessageCode] }}
        <v-btn color="white" text @click="error = false">
          {{ labels.close }}
        </v-btn>
      </v-snackbar>
    </v-container>
    <NewAccount :open-dialog="dialog" @new-account-canceled="dialog = false" />
  </v-app>
</template>

<script>
import axios from 'axios'
import OAuthInfo from '@arcgis/core/identity/OAuthInfo'
import esriId from '@arcgis/core/identity/IdentityManager'
import Portal from '@arcgis/core/portal/Portal'
import * as intl from '@arcgis/core/intl'
import NewAccount from './NewAccount.vue'
import { required } from 'vuelidate/lib/validators'
import { initFbsdk } from '../../facebook/initFb'
import proxy from '../../proxy/proxy'
import { loadLabelingDataFromLocalStorage, loadFilterDataFromLocalStorage, loadSymbologyDataFromLocalStorage } from '../../main'

export default {
  name: 'Login',
  components: {
    NewAccount,
  },
  beforeRouteLeave (to, from, next) {
    if (to.path.includes('/home') && this.$store.getters.getLoggedInUser) {
      this.$store.dispatch('unSetActiveTool')
    }
    next()
  },
  data () {
    return {
      configJson: {},
      username: '',
      password: '',
      loggingIn: false,
      showPass: false,
      error: false,
      snackbarMessageCode: '',
      smartPortal: false,
      arcGISPortal: false,
      isArcGISPortalUrlSupplied: false,
      facebook: false,
      google: false,
      socialNetworkCnt: 0,
      dialog: false,
      loginOnly: false,
      disableCredentialInputFields: false,
      languages: [],
      twoFa: false,
      qrCode: null,
      twoFaCode: '',
    }
  },
  computed: {
    labels () {
      return this.getLabels(this.$store.getters.getLanguage).login
    },
    isSmallScreen () {
      return this.$vuetify.breakpoint.name === 'sm'
    },
    isXSmallScreen () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    logoSrc () {
      if (this.configJson.appConfig.logo) {
        const date = new Date().toString()
        return this.configJson.appConfig.logo + '?date=' + date
      }
      return require('@/assets/logo.png')
    },
    logoLink () {
      if (this.configJson.appConfig.logoLink) {
        return this.configJson.appConfig.logoLink
      }
      return ''
    },
    appName () {
      let title = 'Smart Viewer'
      const language = this.$store.getters.getLanguage
      const localizations = this.$store.getters.getConfigJson.appConfig.localization
      if (!localizations) {
        return title
      }
      for (const localization of localizations) {
        if (localization.id === language) {
          title = localization.name
          break
        }
      }
      return title
    },
    activeIndex () {
      let index = 0
      const language = this.$store.getters.getLanguage
      const localizations = this.$store.getters.getConfigJson.appConfig.localization
      if (!localizations) {
        return index
      }
      index = localizations.findIndex(localization => localization.id === language)
      return index !== -1 ? index : 0
    },
    background () {
      let imgSource = ''
      if (!this.configJson.appConfig) {
        imgSource = require('@/assets/background.jpg')
      } else if (!this.configJson.appConfig.loginPage) {
        imgSource = require('@/assets/background.jpg')
      } else if (!this.configJson.appConfig.loginPage.background) {
        imgSource = require('@/assets/background.jpg')
      } else {
        imgSource = this.configJson.appConfig.loginPage.background
      }
      return 'url(' + imgSource + ')'
    },
    loginMode () {
      return this.$store.getters.getHasLogin
    },
    socialNetwork () {
      if (!this.configJson.appConfig || !this.configJson.appConfig.loginPage || !this.configJson.appConfig.loginPage.socialNetwork) {
        return 0
      }
      return this.configJson.appConfig.loginPage.socialNetwork
    },
    socialNetworkColor () {
      return '#5D7894'
    },
    viewerId () {
      return this.$store.getters.getViewerId
    },
    colNumber () {
      switch (this.socialNetworkCnt) {
        case 1:
          return 12
        case 2:
          return 6
        case 3:
          return 4
        default:
          return 0
      }
    },
    qrStyle () {
      return {
        borderColor: 'white !important',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        marginBottom: '25px',
        paddingLeft: '50px',
        paddingRight: '50px',
        paddingBottom: '50px',
      }
    },
  },
  async created () {
    esriId.destroyCredentials()
    this.configJson = this.$store.getters.getNonMutatedConfigJson
    // in OL implementation we mutate the configjson file to filter out
    // services and layers which we don't have priviliges for
    // this resets the configJson to it's original form, which is necessary
    // in mixed mode login scenario
    this.$store.dispatch('setConfigJson', this.$store.getters.getNonMutatedConfigJson)
    if (this.$store.getters.getOrganisationPortalUrl) {
      this.isArcGISPortalUrlSupplied = true
    }
    if (this.configJson.appConfig) {
      const appConfig = this.configJson.appConfig
      if (appConfig.localization) {
        for (const localization of appConfig.localization) {
          const language = {
            id: localization.id,
            title: localization.id,
          }
          if (language.title === 'cir') {
            language.title = 'ср'
          }
          this.languages.push(language)
        }
      }
    }
    await this.getLoginMethods()
    await this.getLoginPermissions()
  },
  async mounted () {
    try {
      const response = await axios.get('authInfo/smartPortal')
      const facebookId = response.data.facebook_id
      initFbsdk(facebookId)
    } catch (error) {
      console.error(error)
    }
  },
  methods: {
    async getLoginMethods () {
      const response = await axios.get('loginInfo/methods')
      const allLoginMethods = {}
      for (const result of response.data.results) {
        allLoginMethods[result.id] = result.name
      }
      const selectedLoginMethods = this.$store.getters.getLoginMethods
      for (const selectedLoginMethod of selectedLoginMethods) {
        const methodName = allLoginMethods[selectedLoginMethod]
        switch (methodName) {
          case 'Smart Portal':
            this.smartPortal = true
            break
          case 'ArcGIS Portal':
            this.arcGISPortal = true
            this.socialNetworkCnt++
            break
          case 'Google':
            this.google = true
            this.socialNetworkCnt++
            break
          case 'Facebook':
            this.facebook = true
            this.socialNetworkCnt++
            break
          case 'AD':
            if (this.$store.getters.getQuery) {
              localStorage.setItem(this.$store.getters.getViewerName + '-init-params', JSON.stringify(this.$store.getters.getQuery))
            }
            if (this.$store.getters.getViewObject) {
              localStorage.setItem(this.$store.getters.getViewerName + '-viewObject', JSON.stringify(this.$store.getters.getViewObject))
            }
            window.location = '/ad/adauth.html?viewerName=' + this.$store.getters.getViewerName
            break
        }
      }
    },
    async getLoginPermissions () {
      const response = await axios.get('loginInfo/permissions')
      const selectedLoginPermissionFk = this.$store.getters.getLoginPermission
      const permission = response.data.results.find(element => element.id === selectedLoginPermissionFk)
      this.loginOnly = permission.name === 'login'
    },
    async login () {
      this.loggingIn = true
      if (!this.username || !this.password) {
        this.loggingIn = false
        this.error = true
        this.snackbarMessageCode = 'missingCredentials'
        return
      }
      const body = {
        username: this.username,
        password: this.password,
        viewerfk: this.$store.getters.getViewerId,
        viewername: this.$store.getters.getViewerName,
      }
      try {
        const res = await axios.post('/auth', body)
        this.doPostLoginOperations(res)
      } catch (e) {
        this.showErrorSnackbar(undefined, e)
      }
    },
    async loginWithGoogle () {
      this.loggingIn = true
      try {
        const googleUser = await this.$gAuth.signIn()
        const idToken = googleUser.getAuthResponse().id_token
        const body = {
          idtoken: idToken,
          organisationfk: this.$store.getters.getOrganisationId,
          viewerfk: this.$store.getters.getViewerId,
          viewername: this.$store.getters.getViewerName,
          type: this.loginOnly ? 0 : 1,
        }
        try {
          const response = await axios.post('/googleAuth', body)
          console.log('Google login response: ', response)
          this.doPostLoginOperations(response)
        } catch (e) {
          this.showErrorSnackbar(undefined, e)
        }
      } catch (e) {
        this.showErrorSnackbar(undefined, e)
      }
    },
    loginWithFacebook () {
      this.loggingIn = true
      window.FB.login(
        (response1) => {
          if (!response1.authResponse) {
            return
          }
          const body = {
            accessToken: response1.authResponse.accessToken,
            organisationfk: this.$store.getters.getOrganisationId,
            viewerfk: this.$store.getters.getViewerId,
            viewername: this.$store.getters.getViewerName,
            type: this.loginOnly ? 0 : 1,
          }
          try {
            axios.post('fbAuth', body).then((response2) => {
              this.doPostLoginOperations(response2)
            })
          } catch (e) {
            this.showErrorSnackbar(undefined, e)
          }
        },
        { scope: 'email' }
      )
    },
    async loginWithArcGISPortal () {
      this.disableCredentialInputFields = true
      if (!this.$store.getters.getOrganisationPortalUrl) {
        console.error(new Error('portal url not supplied'))
        return
      }

      this.loggingIn = true
      const info = new OAuthInfo({
        appId: this.$store.getters.getPortalAppId,
        portalUrl: this.$store.getters.getOrganisationPortalUrl,
        popupCallbackUrl: window.location.protocol + '//' + window.location.host + (!window.location.host.includes('localhost') ? window.location.pathname : '') + '/oauth-callback.html',
        popup: true,
      })
      esriId.registerOAuthInfos([info])
      try {
        await esriId.getCredential(info.portalUrl + '/sharing')
        const portal = new Portal({ url: this.$store.getters.getOrganisationPortalUrl })
        portal.authMode = 'immediate'
        await portal.load()

        const nameAndSurname = portal.user.fullName.split(' ')
        const name = nameAndSurname[0]
        const surname = nameAndSurname[1]
        const email = portal.user.email
        const avatarUrl = portal.user.getThumbnailUrl()
        let avatar = null
        if (avatarUrl) {
          try {
            const response = await axios.get(avatarUrl, { responseType: 'arraybuffer' })
            avatar = Buffer.from(response.data, 'binary').toString('base64')
          } catch (e) {
            console.error(e)
          }
        }

        const body = {
          avatar: avatar,
          name: name,
          surname: surname,
          email: email,
          viewerfk: this.$store.getters.getViewerId,
          organisationfk: this.$store.getters.getOrganisationId,
          viewername: this.$store.getters.getViewerName,
          type: this.loginOnly ? 0 : 1,
        }
        try {
          const res = await axios.post('/portalAuth', body)
          this.doPostLoginOperations(res)
        } catch (e) {
          this.showErrorSnackbar(undefined, e)
        }
      } catch (e) {
        this.showErrorSnackbar('unexpectedError', e)
      }
      this.disableCredentialInputFields = false
    },
    doPostLoginOperations (res) {
      if (res.data?.qrcode) {
        this.loggingIn = false
        this.qrCode = res.data.qrcode
        this.twoFa = true
        this.twoFaChallenge = true
        localStorage.setItem('twoFaToken', res.data.token)
      } else if (res.data?.twofachallenge) {
        this.loggingIn = false
        this.qrCode = null
        this.twoFa = true
        this.twoFaChallenge = true
        localStorage.setItem('twoFaToken', res.data.token)
      } else if (res.data?.loggedIn) {
        this.loggingIn = false
        const userObject = res.data
        this.$store.dispatch('doLogin', userObject)
        this.updateLocalStorage(userObject)
        const token = this.$store.getters.getAccessToken
        proxy(token, this.configJson)
        this.$router.push('/' + this.$store.getters.getViewerName + '/home')
      } else {
        this.showErrorSnackbar('unexpectedError')
      }

      loadFilterDataFromLocalStorage(this.$store.getters.getViewerName)
      loadLabelingDataFromLocalStorage(this.$store.getters.getViewerName)
      loadSymbologyDataFromLocalStorage(this.$store.getters.getViewerName)
    },
    showErrorSnackbar (message, e) {
      this.loggingIn = false
      this.error = true
      let errorMessage = null
      if (message) {
        errorMessage = message
      } else if (e.response?.data?.message) {
        errorMessage = e.response.data.message
      }

      if (errorMessage === 'No privileges') {
        this.snackbarMessageCode = 'noPrivileges'
      } else if (errorMessage === 'Invalid credentials.' || errorMessage === 'User is not active.') {
        this.snackbarMessageCode = 'invalidCredentials'
      } else if (errorMessage === 'Access not allowed') {
        this.snackbarMessageCode = 'notRegistered'
      } else if (errorMessage === 'tooLong') {
        this.snackbarMessageCode = 'tooLong'
      } else {
        this.snackbarMessageCode = 'unexpectedError'
      }
      if (e) {
        console.error(e)
      }
    },
    updateLocalStorage (userObject) {
      let acceptedTerms = false
      const viewerName = this.$store.getters.getViewerName
      if (localStorage.getItem(window.location.host + '-' + viewerName + '-acceptedTerms')) {
        acceptedTerms = localStorage.getItem(window.location.host + '-' + viewerName + '-acceptedTerms')
      }
      const user = {
        loggedInUser: userObject.loggedInUser,
        token: userObject.token,
        refreshToken: userObject.refreshToken,
      }
      localStorage.setItem(window.location.host + '-' + viewerName + '-loggedInUser', JSON.stringify(user))
      localStorage.setItem(window.location.host + '-' + viewerName + '-acceptedTerms', acceptedTerms)
      this.$store.dispatch('setAcceptedTerms', acceptedTerms)
    },
    setLanguage (item, index) {
      if (['sr', 'cir', 'ba'].includes(item.id)) {
        intl.setLocale('sr')
      } else {
        intl.setLocale('en-US')
      }
      const data = {
        language: item.id,
        viewer: this.$store.getters.getViewerName,
        host: window.location.host,
      }
      this.$store.dispatch('setLanguage', data)
    },
    async login2fa () {
      this.loggingIn = true
      const body = {
        code: this.twoFaCode,
        viewerfk: this.$store.getters.getViewerId,
      }
      try {
        const res = await axios.post('/twoFaAuth', body, { headers: { Authorization: 'Bearer ' + localStorage.getItem('twoFaToken') } })
        this.loggingIn = false
        if (res.data && res.data.loggedIn) {
          localStorage.removeItem('twoFaToken')
          this.doPostLoginOperations(res)
        } else if (res.data.expired) {
          this.loggingIn = false
          this.showErrorSnackbar('tooLong')
        } else {
          this.loggingIn = false
          this.showErrorSnackbar('unexpectedError')
        }
      } catch (error) {
        console.log(error)
        this.loggingIn = false
        this.showErrorSnackbar('unexpectedError', error)
      }
    },
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    },
  },
}
</script>

<style scoped>
.background {
  width: 100%;
  height: 100%;
  background-size: cover;
}
.no-uppercase {
  text-transform: none;
}
.app-name {
  font-size: 28px;
  word-break: break-word;
  text-overflow: ellipsis;
}
.raisedbox {
  box-shadow: inset 0 0 1px #000000;
}
</style>
